// What to show when a code is refused during 2FA setup (OL-230). The server
// now explains what to check; before OL-230 it only said "OTP invalid or
// expired". Returns null for any other error.
const FALLBACK = 'That code did not match. In your authenticator app, use the newest OAK.LEGAL entry and delete older ones, check that your phone sets its date and time automatically, then enter the next code.';

export const setupCodeRejection = (message = '') => {
  if (message.startsWith('That code did not match')) return message;
  if (message === 'OTP invalid or expired') return FALLBACK;
  return null;
};
